<template>
  <div>
    marketHome list
  </div>
</template>

<script>

export default {
  name: 'marketHome',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>